<template>
  <img
    :style="getImgStyle"
    v-show="loadedThumb"
    id="image"
    :src="getSrcThumb"
    @load="loadedThumbImage"
    alt="immagine profilo utente"
    :class="getClass"
  />
</template>
<script>
export default {
  name: 'contactAvatar',
  props: {
    contactId: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 50,
    },
    height: {
      type: Number,
      default: 50,
    },
    borderRadius: {
      type: Number,
      default: 0,
    },
  },
  data: function() {
    return {
      contactID: '',
      imageThumb: '',
      loadedThumb: false,
      currentClass: 'img-visible',
    }
  },
  created() {
    if (this.contactId) {
      this.contactID = this.contactId
    }
  },
  mounted() {
    if (this.contactID) {
      this.setImageUrl()
    }
  },
  watch: {
    contactId: function(newId, oldId) {
      if (newId && newId !== oldId) {
        this.contactID = newId
        this.setImageUrl()
      }
    },
  },
  computed: {
    getSrcThumb: function() {
      let thumb = this.imageThumb
        ? 'data:image/png;base64,' + this.imageThumb
        : ''
      return thumb
    },
    getImgStyle: function() {
      let styleString =
        'width:' + this.width + 'px;height:' + this.height + 'px;'
      if (this.borderRadius) {
        styleString += 'border-radius:' + this.borderRadius + 'px;'
      }
      return styleString
    },
    getClass: function() {
      return this.currentClass
    },
  },
  methods: {
    loadedThumbImage: function() {
      this.loadedThumb = true
    },
    setImageUrl: async function() {
      this.loadedThumb = false
      let thumbFromDb
      let whereForQuery = {
        docType: 'profileImage',
        'ref.contactId': this.contactID,
      }
      let fieldsForQuery = { thumb64: true }
      try {
        const filter = {
          where: whereForQuery,
          fields: fieldsForQuery,
        }
        let result = await this.$api.get('TzbFs', filter)
        thumbFromDb = result[0]
      } catch (error) {
        console.log('setImageUrl: errore richiesta thumb')
      }
      if (thumbFromDb && thumbFromDb.thumb64) {
        if (this.imageThumb === thumbFromDb.thumb64) {
          this.loadedThumb = true
        } else {
          this.imageThumb = thumbFromDb.thumb64
        }
      }
    },
  },
}
</script>
<style scoped>
#image {
  object-fit: cover;
}
.img-visible {
  display: unset;
}
.img-hidden {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/avatar.vue